import React from "react";
import { TiSocialLinkedinCircular } from "react-icons/ti";
import { Link } from "react-router-dom";

const LPFooter = () => {
  return (
    <footer className="bg-[#1D3585] text-white py-8">
      <div className="container mx-auto px-4">
        {/* Main flex container: stacks in reverse on mobile, horizontally on medium screens and up */}
        <div className="flex flex-col-reverse md:flex-row items-center md:items-start text-center md:text-left gap-8">
          {/* Left Section (Logo & Social) */}
          <div className="flex flex-col items-center md:items-start">
            <div className="flex items-center">
              <h5
                className="text-xl text-white mr-1"
                style={{ marginBottom: "0" }}
              >
                Follow Us
              </h5>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.linkedin.com/company/scholarty"
                className="hover:text-[#98B9FE]"
              >
                <TiSocialLinkedinCircular className="text-4xl text-[#98B9FE]" />
              </a>
            </div>
            <div className="pt-4">
              <h3 className="text-3xl text-white font-semibold">scholarty</h3>
              <h3 className="text-xl text-white">
                Built by students, for students.
              </h3>
            </div>
          </div>

          {/* Right Section (Links) - Pushed to the right with ml-auto */}
          <div className="w-full md:w-auto md:ml-auto">
            {/* Links container: stacks vertically and centers on mobile */}
            <div className="flex flex-col md:flex-row flex-wrap items-center md:items-end justify-center md:justify-end gap-4 md:gap-8 text-xl">
              <Link
                to="/about"
                className="relative hover:text-[#98B9FE] transition-colors cursor-pointer group"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              >
                About Us
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#98B9FE] group-hover:w-full transition-all duration-300 ease-in-out"></span>
              </Link>
              <Link
                to="/faq"
                className="relative hover:text-[#98B9FE] transition-colors cursor-pointer group"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              >
                FAQ
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#98B9FE] group-hover:w-full transition-all duration-300 ease-in-out"></span>
              </Link>
              <Link
                to="/privacy"
                className="relative hover:text-[#98B9FE] transition-colors cursor-pointer group"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              >
                Privacy Policy
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#98B9FE] group-hover:w-full transition-all duration-300 ease-in-out"></span>
              </Link>
              <h5 className="text-xl">
                Contact Info:
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="mailto:contact@scholarty.com"
                  className="relative text-[#98B9FE] group"
                >
                  {" "}
                  contact@scholarty.com
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#98B9FE] group-hover:w-full transition-all duration-300 ease-in-out"></span>
                </a>
              </h5>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LPFooter;
